import type { Passbook } from '@/shared/types';

export interface BackFieldBlock {
  id: string;
  title: string;
  labelKey: keyof Passbook & string;
  valueKey: keyof Passbook & string;
}

/** Até 10 blocos — espelha fieldFirst…fieldTenth do Wallet. */
export const BACK_FIELD_BLOCKS: BackFieldBlock[] = [
  { id: '1', title: 'Bloco 1', labelKey: 'fieldFirstFixedLabel', valueKey: 'fieldFirstFixedValue' },
  { id: '2', title: 'Bloco 2', labelKey: 'fieldSecondFixedLabel', valueKey: 'fieldSecondFixedValue' },
  { id: '3', title: 'Bloco 3', labelKey: 'fieldThirdFixedLabel', valueKey: 'fieldThirdFixedValue' },
  { id: '4', title: 'Bloco 4', labelKey: 'fieldFourthFixedLabel', valueKey: 'fieldFourthFixedValue' },
  { id: '5', title: 'Bloco 5', labelKey: 'fieldFifthFixedLabel', valueKey: 'fieldFifthFixedValue' },
  { id: '6', title: 'Bloco 6', labelKey: 'fieldSixthFixedLabel', valueKey: 'fieldSixthFixedValue' },
  { id: '7', title: 'Bloco 7', labelKey: 'fieldSeventhFixedLabel', valueKey: 'fieldSeventhFixedValue' },
  { id: '8', title: 'Bloco 8', labelKey: 'fieldEighthFixedLabel', valueKey: 'fieldEighthFixedValue' },
  { id: '9', title: 'Bloco 9', labelKey: 'fieldNinthFixedLabel', valueKey: 'fieldNinthFixedValue' },
  { id: '10', title: 'Bloco 10', labelKey: 'fieldTenthFixedLabel', valueKey: 'fieldTenthFixedValue' },
];

export const MAX_BACK_FIELD_BLOCKS = BACK_FIELD_BLOCKS.length;

export type BackFieldsPayload = Record<string, string>;

export function emptyBackFields(): BackFieldsPayload {
  const payload: BackFieldsPayload = {};
  for (const block of BACK_FIELD_BLOCKS) {
    payload[block.labelKey] = '';
    payload[block.valueKey] = '';
  }
  return payload;
}

export function passbookToBackFields(passbook: Passbook): BackFieldsPayload {
  const payload = emptyBackFields();
  for (const block of BACK_FIELD_BLOCKS) {
    payload[block.labelKey] = String(passbook[block.labelKey] ?? '');
    payload[block.valueKey] = String(passbook[block.valueKey] ?? '');
  }
  return payload;
}

/** Quantos slots mostrar: 1 se vazio; senão até o último bloco com conteúdo. */
export function countVisibleBlocks(payload: BackFieldsPayload): number {
  let last = 0;
  for (let i = 0; i < BACK_FIELD_BLOCKS.length; i++) {
    const block = BACK_FIELD_BLOCKS[i];
    const label = (payload[block.labelKey] ?? '').trim();
    const value = (payload[block.valueKey] ?? '').trim();
    if (label || value) last = i + 1;
  }
  return Math.max(1, last);
}

/** Corpo do PUT: textos do verso e, quando o bloco MGM existe, o liga/desliga. */
export type VersoSavePayload = Record<string, string | boolean>;

/** Payload de save: slots além de `visibleCount` vão vazios (some no Wallet). */
export function buildSavePayload(
  fields: BackFieldsPayload,
  visibleCount: number,
  showMgmBackLink?: boolean,
): VersoSavePayload {
  const payload: VersoSavePayload = { ...emptyBackFields() };
  const count = Math.min(Math.max(visibleCount, 1), MAX_BACK_FIELD_BLOCKS);
  for (let i = 0; i < count; i++) {
    const block = BACK_FIELD_BLOCKS[i];
    payload[block.labelKey] = fields[block.labelKey] ?? '';
    payload[block.valueKey] = fields[block.valueKey] ?? '';
  }
  if (typeof showMgmBackLink === 'boolean') payload.showMgmBackLink = showMgmBackLink;
  return payload;
}
